import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ClearFormDialog({
  open,
  onClose,
  onSuccess,
}: {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
    >
      <DialogTitle
        color="#F00F00"
        fontWeight={700}
        fontSize="20px"
        letterSpacing="-0.08px"
      >
        Clear plan?
      </DialogTitle>
      <DialogContent>
        <Typography
          color="#525F81"
          fontWeight={400}
          fontSize="14px"
          lineHeight="20px"
        >
          {t(
            'Are you sure you want to clear the data? This will also clear all the data in all the country forms. This action is irreversible.'
          )}
        </Typography>
        <Typography
          color="#525F81"
          fontWeight={400}
          fontSize="14px"
          lineHeight="20px"
          mt={2}
        >
          {t('Proceed?')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: '0 16px 16px 16px' }}>
        <Button
          onClick={onClose}
          sx={{
            background: '#f0f0f3',
            color: '#60646C',
            borderRadius: '4px',
            '&:hover': {
              background: '#d9d9dc',
              color: '#60646C',
            },
          }}
        >
          {t('Cancel')}
        </Button>
        <Button
          onClick={onSuccess}
          sx={{
            background: '#e5484d',
            color: 'white',
            borderRadius: '4px',
            '&:hover': {
              background: '#d13c42',
              color: 'white',
            },
          }}
        >
          {t('Proceed')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
